import { Injectable, Injector } from '@angular/core'
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent, HttpResponse, HttpUserEvent, HttpClient, HttpHeaders } from '@angular/common/http'
import { throwError, Observable } from 'rxjs'
import { environment } from 'src/environments/environment'
import { catchError, flatMap, last } from 'rxjs/operators'
import { LocalstorageService } from './localstorage.service'
import { NGXLogger } from 'ngx-logger'
import { ACCOUNT_AUTH_URL } from '../../modules/account/account-api'
import { USER_LOGIN_GROUP } from '../../modules/account/account-api'
import { ACCOUNT_AUTH_GROUP } from '../../modules/account/account-api'
import { LoginAuthInterceptorExtension } from './login-auth.interceptor.extension'
import { NinthWaveAuthInterceptorExtension } from './ninthwave-auth.interceptor.extension'
import { SharedDataService } from 'src/app/core/services/shared-data.service'
import { RuntimeConfigService } from '../../../app/runtime-config.service'

class RefreshTokenOptions {
  type: 'dso' | 'account'
  accessToken: string
  refreshToken: string
  appId: string
  appPwd: string
  authUrl: string
}

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  equipmentProviderInActive: boolean;
  API_CDN_URL : string;
  constructor(
    public logger: NGXLogger,
    private http: HttpClient,
    private sessionStorage: LocalstorageService,
    private loginInterceptor: LoginAuthInterceptorExtension,
    public sharedDataService: SharedDataService,
    private ninthWaveInterceptor: NinthWaveAuthInterceptorExtension,
    private runtimeConfigService: RuntimeConfigService
    ) { 
      this.equipmentProviderInActive = this.sharedDataService.getPortalType();
      if(this.equipmentProviderInActive){
        this.API_CDN_URL = environment.API_EQUIP_PROVIDER_CDN_URL
      } else {
        this.API_CDN_URL = environment.API_DENTAL_CDN_URL
      }
    }

  refreshDsoToken = ''
  APP_DSO_ACCESS_TOKEN = 'appAccessToken'
  APP_DSO_REFRESH_TOKEN = 'appRefreshToken'

  refreshAccountToken = ''
  APP_ACCOUNT_ACCESS_TOKEN = 'accountAccessToken'
  APP_ACCOUNT_REFRESH_TOKEN = 'accountRefreshToken'


  cutRequestUrl(url: string): string {
    // handle / at the end
    if (url.charAt(url.length - 1) === '/') {
      url = url.substring(0, url.length - 1)
    }

    const lastMorphem = url.substring(url.lastIndexOf('/'))
    // if last morphem is number
    if (!isNaN(+lastMorphem)) {
      // cut last /$id if it ends with valid number
      url = url.substring(0, url.lastIndexOf('/'))
    }

    const eqPos = url.lastIndexOf('=')
    if (eqPos !== -1) {
      url = url.substring(0, eqPos)
    }
    return url
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<
    | HttpSentEvent
    | HttpHeaderResponse
    | HttpProgressEvent
    | HttpResponse<any>
    | HttpUserEvent<any>
    > {
    const cutUrl = this.cutRequestUrl(request.url)
    // after user already login in - use it token
    if(cutUrl.includes(this.API_CDN_URL)){
      return next.handle(request)
    }
    const mapped = Object.values(USER_LOGIN_GROUP).filter(x =>
      x.includes(cutUrl) && cutUrl || cutUrl.includes(x)
    )
    
    if (mapped.length > 0 && mapped[0] != `${environment.LOAN_QUOTE_URL}/system/v1/config/global/var`) {
      return this.loginInterceptor.intercept(request, next)
    }

    // common requests - use account token
    if (Object.values(ACCOUNT_AUTH_GROUP).includes(cutUrl)) {
      return this.useAccountToken(request, next)
    }


    const ninthWaveBase = environment.NINTHWAVE_BASE_URL
    if (request.url.includes(ninthWaveBase)) {
      return this.ninthWaveInterceptor.intercept(request, next)
    }

    // regular old DSO
    return this.useMainToken(request, next)
  }

  private useAccountToken(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<
    | HttpSentEvent
    | HttpHeaderResponse
    | HttpProgressEvent
    | HttpResponse<any>
    | HttpUserEvent<any>
  > {
    const accountToken = this.sessionStorage.getItem(this.APP_ACCOUNT_ACCESS_TOKEN)
    if (accountToken) {
      this.logger.info('attach account token')
      request = this.attachToken(request, this.APP_ACCOUNT_ACCESS_TOKEN)
    }
    const accountAuthOptions: RefreshTokenOptions = {
      type: 'account',
      accessToken: this.APP_ACCOUNT_ACCESS_TOKEN,
      refreshToken: this.APP_ACCOUNT_REFRESH_TOKEN,
      // TODO: NOTE: using the same appId and appPwd as in phase1
      //appId: this.equipmentProviderInActive?environment.AUTH_LOANAPP_EQUIPPROVIDER_APPID:environment.AUTH_LOANAPP_DENTAL_APPID,
      //appPwd: this.equipmentProviderInActive?environment.AUTH_LOANAPP_EQUIPPROVIDER_PWD:environment.AUTH_LOANAPP_DENTAL_PWD,
      appId: this.equipmentProviderInActive? this.runtimeConfigService.equipmentProviderLoanAppId:this.runtimeConfigService.dentalLoanAppId,
      appPwd: this.equipmentProviderInActive?this.runtimeConfigService.equipmentProviderLoanAppPassword:this.runtimeConfigService.dentalLoanAppPassword,
      authUrl: ACCOUNT_AUTH_URL,
    }
    return this.renewTokenOnError(next, request, accountAuthOptions)
  }


  private useMainToken(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<
    | HttpSentEvent
    | HttpHeaderResponse
    | HttpProgressEvent
    | HttpResponse<any>
    | HttpUserEvent<any>
  > {
    const dsoToken = this.sessionStorage.getItem(this.APP_DSO_ACCESS_TOKEN)
    if (dsoToken) {
      request = this.attachToken(request, this.APP_DSO_ACCESS_TOKEN)
    }
    const dsoAuthOptions: RefreshTokenOptions = {
      type: 'dso',
      accessToken: this.APP_DSO_ACCESS_TOKEN,
      refreshToken: this.APP_DSO_REFRESH_TOKEN,
      //appId: this.equipmentProviderInActive?environment.AUTH_DSO_EQUIPPROVIDER_APPID:environment.AUTH_DSO_DENTAL_APPID,
      //appPwd: this.equipmentProviderInActive? environment.AUTH_DSO_EQUIPPROVIDER_PWD : environment.AUTH_DSO_DENTAL_PWD,
      appId: this.equipmentProviderInActive? this.runtimeConfigService.equipmentProviderDSOAppId:this.runtimeConfigService.dentalDSOAppId,
      appPwd: this.equipmentProviderInActive? this.runtimeConfigService.equipmentProviderDSOPassword : this.runtimeConfigService.dentalDSOPassword,
      authUrl: `${environment.AUTH_DSO_URL}/authenticateApp`,
    }
    return this.renewTokenOnError(next, request, dsoAuthOptions)
  }

  private renewTokenOnError(next, request, options: RefreshTokenOptions) {
    return next.handle(request).pipe(
      catchError((err) => {

        const accountTokenNotAttached = 'Missing request header \'Authorization\' for method parameter of type String'
        const accountBadRequest ='Bad Request'
        // console.log(err.message)
        if (
          // usage for account only, 400 code can be "with missed Authorization header"
          // tslint:disable-next-line: tsr-detect-possible-timing-attacks
          //(options.type === 'account' && err.status === 400 && err.error.message === accountTokenNotAttached)
          ((options.type === 'account' || options.type === 'dso') && err.status === 400 && 
          (err.message === accountTokenNotAttached || err.error.error === accountBadRequest))
          // usual usage, works on phase1
          || err.status === 401 || err.status === 403
        ) {
          this.logger.info(`renew ${options.type} token`)
          const appId = options.appId
          const appPwd = options.appPwd
          const authBody = {
            appId,
            appPwd,
          }
          const headers = new HttpHeaders()
          return this.http
            .post(
              `${options.authUrl}`,
              authBody,
              { headers }
            )
            .pipe(
              flatMap((data: any) => {
                if (data.status === 'OK') {
                  this.sessionStorage.setItem(
                    options.accessToken,
                    data.resultMap.accessToken
                  )
                  this.sessionStorage.setItem(
                    options.refreshToken,
                    data.resultMap.refreshToken
                  )
                  // for flexibility of tokens
                  switch (options.type) {
                    case 'dso':
                      this.refreshDsoToken = data.resultMap.refreshToken
                      break
                    case 'account':
                      this.refreshAccountToken = data.resultMap.refreshToken
                      break
                  }

                  request = this.sessionStorage
                    .getItem(options.accessToken) !== undefined
                    ? this.attachToken(request, options.accessToken)
                    : this.attachRefreshToken(request, data.resultMap.refreshToken)
                  return next.handle(request)
                }
              })
            )
        }
        return throwError(err)
      })
    )
  }


  private attachToken(request: HttpRequest<any>, accessToken) {
    if (request.url.search('/authenticateApp') === -1 && request.url.search('/fraud/affidavit') === -1) {
      const token = this.sessionStorage.getItem(accessToken)
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      })
    }
    return request
  }

  private attachRefreshToken(request: HttpRequest<any>, refreshToken) {
    if (request.url.search('/authenticateApp') === -1 && request.url.search('/fraud/affidavit') === -1) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${refreshToken}`,
        },
      })
    }
    return request
  }
}
